import { render, staticRenderFns } from "./LevelCustomers.vue?vue&type=template&id=2bc0b030&scoped=true&"
import script from "./LevelCustomers.vue?vue&type=script&lang=js&"
export * from "./LevelCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc0b030",
  null
  
)

export default component.exports